import Reports from "../../components/Reports/Reports";

const reportRoutes = [
    {
        path: '', name: 'reports', component: Reports,
    },
];

export default reportRoutes;
